const traffic = {
  't-global-config': 'Configuration Globale',
  't-save-config': 'Enregistrer Config',
  't-time-window': 'Fenêtre de Temps',
  't-time-window-seconds': 'Fenêtre de Temps (s)',
  't-max-download-count': 'Téléchargements Max',
  't-max-retry-count': 'Tentatives Max',
  't-global-config-hint': 'Les Partners sans configuration individuelle utiliseront cette valeur par défaut globale. S\'applique uniquement aux appareils mpush.',
  't-circuit-breaker-strategy': 'Stratégie de Disjoncteur',
  't-circuit-breaker-enabled': 'Ce Partner appliquera une stratégie de disjoncteur indépendante',
  't-circuit-breaker-disabled': 'Utiliser la configuration globale si désactivé',
  't-config-params': 'Paramètres de Configuration',
  't-time-window-label': 'Fenêtre de Temps',
  't-max-download-label': 'Téléchargement Max',
  't-max-retry-label': 'Tentatives Max',
  't-ban-behavior-title': 'Description du Comportement de Blocage',
  't-ban-behavior-desc': 'Tentatives épuisées → L\'appareil entre en état banni → Toutes les demandes de téléchargement dans la fenêtre actuelle renvoient {0}, l\'appareil arrête le téléchargement',
  't-download-settings': 'Paramètres de Téléchargement',
  't-traffic-mgmt': 'Gestion du Trafic',
  "t-error-download-settings": "Limiteur de débit",
  't-add-config': 'Ajouter Configuration',
  't-edit-config': 'Modifier Configuration',
  't-status-enabled': 'Activé',
  't-status-disabled': 'Désactivé',
  't-select-partner': 'Veuillez sélectionner un Partner',
  't-select-partner-required': 'Veuillez sélectionner un Partner',
  't-fill-time-window': 'Veuillez remplir la fenêtre de temps',
  't-save-success': 'Enregistré avec succès',
  't-save-failed': 'Échec de l\'enregistrement',
  't-update-success': 'Mis à jour avec succès',
  't-update-failed': 'Échec de la mise à jour',
  't-add-success': 'Ajouté avec succès',
  't-add-failed': 'Échec de l\'ajout',
  't-load-failed': 'Échec du chargement des données',
  't-second': 's',
  't-times': 'fois',
  't-fill-max-download': 'Veuillez remplir le nombre max de téléchargements',
  't-fill-allowed-retry': 'Veuillez remplir le nombre de tentatives autorisées',
  't-time-window-range-error': 'La fenêtre de temps doit être entre 1 et 7200',
  't-max-download-range-error': 'Le nombre max de téléchargements doit être entre 5 et 200',
  't-allowed-retry-range-error': 'Le nombre de tentatives doit être entre 1 et 20',
  't-traffic-overview': 'Vue d\'ensemble du Trafic',
  't-monthly-total-traffic': 'Trafic Total du Mois',
  't-compared-last-month': 'par rapport au mois dernier',
  't-partner-count': 'Nombre de Partners',
  't-this-month-new': 'nouveaux ce mois-ci',
  't-over-limit-partner': 'Partners Hors Limite',
  't-need-attention': 'À surveiller',
  't-all-partner': 'Tous les Partners',
  't-all-usage-rate': 'Tous les Taux d\'Utilisation',
  't-current-month-used-traffic': 'Trafic Utilisé Ce Mois',
  't-traffic-limit': 'Limite de Trafic',
  't-usage-rate': 'Taux d\'Utilisation',
  't-this-month-download-count': 'Téléchargements Ce Mois',
  't-normal': 'Normal',
  't-about-to-exceed': 'Bientôt Hors Limite',
  't-exceeded': 'Dépassé',
  't-unlimited': 'Illimité',
  't-unlimited-traffic': 'Trafic Illimité',
  't-view-traffic-detail': 'Voir les détails du trafic',
  't-download-records': 'Téléchargements Ce Mois',
  't-file-name': 'Nom du Fichier',
  't-file-size': 'Taille du Fichier',
  't-usage-history': 'Historique d\'Utilisation des Données',
  't-data-usage-trend': 'Tendance d\'Utilisation des Données',
  't-last-30-days-data-usage-trend': 'Tendance d\'utilisation des données des 30 derniers jours',
  't-used-traffic': 'Trafic Utilisé',
  't-last-12-months-traffic-trend': 'Tendance du Trafic des 12 Derniers Mois',
  't-month': 'Mois',
  't-all-months': 'Tous les Mois',
  't-download-count': 'Nombre de Téléchargements',
  't-quota-configuration': 'Limites de trafic',
  't-global-default-config': 'Configuration Globale par Défaut',
  't-global-default-traffic-limit': 'Limite Globale de Trafic par Défaut',
  't-current-config': 'Configuration Actuelle',
  't-quota-global-config-hint': 'Les Partners sans configuration individuelle de limite de trafic utiliseront cette valeur par défaut. Définissez 0 pour un trafic illimité.',
  't-partner-traffic-limit-config': 'Configuration de Limite de Trafic Partner',
  't-config-type': 'Type de Configuration',
  't-use-global': 'Utiliser Global',
  't-custom': 'Personnalisé',
}

export default traffic
